import React from 'react';
import { Building2 } from 'lucide-react';

/*
 * B2B marker.
 *
 * This is load-bearing information for the business, not a footnote — a B2B
 * order is handled, priced and invoiced differently — so it is the one
 * classification on the screen allowed to carry real visual weight. Solid ink
 * rather than a tint: it outranks the status pills beside it without
 * introducing a competing hue into a palette where colour means state.
 */
const B2BTag = ({ size = 'sm', showIcon = false }) => (
  <span
    title="Business-to-business order"
    className={[
      'inline-flex items-center gap-1 font-bold tracking-[0.06em] rounded',
      'bg-nysmah-dark text-white',
      size === 'sm'
        ? 'px-1.5 py-[3px] text-[9.5px] leading-none'
        : 'px-2.5 py-1 text-[11px] leading-none',
    ].join(' ')}
  >
    {showIcon && (
      <Building2
        className={size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3'}
        aria-hidden="true"
      />
    )}
    B2B
  </span>
);

export default B2BTag;
